import { useRef } from 'react'
import { PlinkoBet } from 'views/InhouseGame/Plinko/types/Bet'
import { useGlobalMatter } from 'views/InhouseGame/hooks/useMatter'
import { plinkoSizes, particleSizeMuliplier, canvasWidth, plinkoDistancesX, payoutResult } from '../../../config'
import Particle from '../modals/Particle'

const useGameParticles = (row: number) => {
  const particlesRef = useRef<Particle[]>([])
  const particleSize = plinkoSizes[row] * particleSizeMuliplier
  const Matter = useGlobalMatter()

  const createParticle = (bet: PlinkoBet) => {
    const startX = canvasWidth / 2 - plinkoDistancesX[row] + 1
    const rowPayoutOutcome = payoutResult[row][bet.payoutIndex]
    const randomIndex = Math.floor(Math.random() * rowPayoutOutcome.length)
    const x = startX + Number(rowPayoutOutcome[randomIndex])
    const y = 5

    const particle = new Particle(Matter, {
      x,
      y,
      size: particleSize,
      bet,
    })

    particlesRef.current.push(particle)
    return particle
  }

  return {
    createParticle,
    particles: particlesRef.current,
  }
}

export default useGameParticles
